<template>
  <BlogLayout
    :heading="formattedTitle"
    :breadcrumbItems="computedBreadcrumbItems"
    :faqHelpfulData="faqSidebarData"
    :showForFaQSidebar="true"
    :showFaqSearchTips="true"
    layoutId="faqs-blog-layout-detail"
  >
    <div class="lg:col-span-3">
      <hr class="border-0 absolute left-0 w-full md:w-[80vw]" aria-hidden="true"/>
      <faqListingVue/>
    </div>
  </BlogLayout>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import {computed,onMounted} from "vue"
import { URL_CONFIG } from "~~/shared/utils/url.const";
import { CATEGORY_DETAILS } from "~~/shared/utils/contentTypes.js";
import type { BreadcrumbItem } from "~~/shared/types/common";
import { useFaqDetail } from "~/composables/useFaqs";
import BlogLayout from "~/layouts/blogLayout.vue";
import faqListingVue from "~/components/ui/organism/faq/faqListing.vue";

const route = useRoute();
const slug = route?.path.split('/').filter(Boolean).pop() ?? ''; 
const faqQuery = computed(() => String(route.query.q ?? '').trim())

const formattedTitle = computed(() => {
  if (route.params.slug?.[0] === 'search' && faqQuery.value) {
    return `Search results for '${faqQuery.value}'`
  }

  return slug
    .replace(/-/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase())
    .replace(/\bAnd\b/g, 'and')
})

const question = `FAQs ${formattedTitle}`;
const pageTitle = computed(() => `${question} | Thorne`);

useHead({
  title: pageTitle
})

defineProps<{
  question?: string
  answer?: string
}>()

definePageMeta({
  validate: (route) => {
    const slug = route.params.slug?.[0]

    if (slug === 'search') return true

    return CATEGORY_DETAILS.some(item =>
      item.url.endsWith(`/${slug}`)
    )
  }
})

const {
  faq, 
  faqSidebarData,
  error, 
  pending, 
  refresh
} = useFaqDetail(slug);

const computedBreadcrumbItems = computed<BreadcrumbItem[]>(() => {
  const newcat = slug.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase()).replace(/\bAnd\b/g, 'and')
  const items: BreadcrumbItem[] = [
    { label: "Home", href: "/" },
    { label: "FAQs", href: URL_CONFIG.FAQS },
  ];

  slug !== 'search' && items.push({ label: newcat, href: slug });
  
  return items;
});

onMounted(() => {
  refresh(); 
});
</script>
